import React, { PropTypes } from 'react';
import moment from 'moment';

import './style.scss';

const ChatInfoScheduledSession = (props) => {
  const { scheduledChatSessionStartDate } = props;
  const hasSession = scheduledChatSessionStartDate !== undefined;
  if (!hasSession) return null;

  const now = moment();
  const sessionIsToday = scheduledChatSessionStartDate.isSame(now, 'day');
  const hasStarted = scheduledChatSessionStartDate.diff(now) < 0;

  // Do not show this panel if the session has started or there is no session to show
  if (hasStarted) return null;

  return (
    <div className="ChatInfoScheduledSession">
      {sessionIsToday
        ? <div>
            <h4>{__('members.chat.scheduled.nextTitle')}</h4>
            <p>{scheduledChatSessionStartDate.fromNow()} ({scheduledChatSessionStartDate.format('hh:mm a')})</p>
          </div>
        : <div>
            <h4>{__('members.chat.scheduled.nextTitle')}</h4>
            <p>{scheduledChatSessionStartDate.format('hh:mm a, D MMMM YYYY')}</p>
          </div>
      }
    </div>
  );
};

ChatInfoScheduledSession.propTypes = {
  scheduledChatSessionStartDate: PropTypes.object
};

export default ChatInfoScheduledSession;




/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadsList/ChatInfo/ChatInfoScheduledSession/index.js
 **/